<script>
import transportTypes from '../../variables/transportTypes';

export default {
  name: 'NonDynamicTransportTypes',
  props: {
    transportType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      radio: '',
      flight: transportTypes.FLIGHT,
      train: transportTypes.TRAIN,
      cruise: transportTypes.CRUISE,
    };
  },
  methods: {
    setTransportType(transportType) {
      this.$emit('set-transport-type', transportType);
    },
  },
};
</script>

<template>
  <div>
      <v-radio-group
        :value="transportType"
        @change="setTransportType($event)"
      >
        <v-layout row>
          <v-radio
            class="pb-3"
            value="flight"
            :label="$t('nonDynamicTransport.labels.flight')"
          />
          <v-radio
            class="pb-3"
            value="cruise"
            :label="$t('nonDynamicTransport.labels.cruise')"
          />
          <v-radio
            class="pb-4"
            value="train"
            :label="$t('nonDynamicTransport.labels.train')"
          />
        </v-layout>
      </v-radio-group>
  </div>
</template>

<style lang="scss" scoped>
  /deep/ .v-input--selection-controls .v-input__control {
    height: 30px;
    margin-top: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportTypes.vue